module.exports = __webpack_public_path__ + "static/media/difc.ac2a620c.png";